import { $ABTest } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import _get from 'lodash/get';

export const $UseSchemaDirectCall = atom((get) => {
  const { parameters } = get($ABTest);

  if ((__BUILD_TYPE__ as any) === 'local_dev') {
    return true;
  }

  return Boolean(_get(parameters, ['web', 'schema_direct_call'], false));
});
